export default __webpack_public_path__ + "static/media/Rustam.15570d1c.png";